import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CustomFieldMappingEnriched, CustomFieldParent, DomainType } from '@jms/model';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomFieldService {

  // The custom fields mapping route lives on the tenant API. In a portal context the
  // request must go to the portal-prefixed tenant URL (resolved by the portal HTTP
  // interceptor's __tenant__ replacement), otherwise it 404s against the portal host
  // and the modal shows "No custom fields available" (WBS-9086).
  public mappingApi = this.resolveMappingApi();

  constructor(private http: HttpClient) { }

  private resolveMappingApi(): string {

    switch (ConfigService.environment.domainType) {
      case DomainType.ClientPortal:
        return `https://__tenant__/api/portal/clients/customfields/mapping/parents`;

      case DomainType.ContractorPortal:
        return `https://__tenant__/api/portal/contractor/customfields/mapping/parents`;

      default:
        return `/api/customfields/mapping/parents`;
    }
  }

  public async getCustomFieldMapping(parent: CustomFieldParent, onNew = false): Promise<CustomFieldMappingEnriched[]> {

    const url = onNew
      ? `${this.mappingApi}/${parent}?onNew=true`
      : `${this.mappingApi}/${parent}`;

    const mappings = await this.http.get<CustomFieldMappingEnriched[]>(url)
      .pipe(
        map(x => x),
        catchError(error => {

          console.log(error);
          return [];
        })
      ).toPromise();

    return mappings;

  }
}
